import { isNative } from './is';

// For emitting events in NewRelic relating to how frequently a feature is used or an action is taken
export const logMobileUsage = (eventName, attributes = null) => {
    if (isNative()) {
        import('@newrelic/newrelic-capacitor-plugin').then((module) => {
            module.NewRelicCapacitorPlugin.recordCustomEvent({
                eventType: 'mobileUsage',
                eventName: eventName,
                attributes: attributes ?? {}
            });
        });
    }
};

export const logMobileUsageMetrics = (name) => {
    // for some reason these metrics do not show up in New Relic
    if (isNative()) {
        import('@newrelic/newrelic-capacitor-plugin').then((module) => {
            module.NewRelicCapacitorPlugin.recordMetric({
                name: `Custom/ImageQuality/${name}`,
                category: 'ImageQuality'
            });
        });
    }
};
